export default "__VITE_ASSET__BItehYyf__"